import { useEffect } from "react";
import { toast } from "react-toastify";
import { PARCEL_STATUS_UPDATE_EVENT } from "../types/parcelBookingSignalR.types";
import getSignalRService from "../services/signalRService";
import { refreshCustomerDashboardData } from "../utils/customerDashboardRefresh";
import {
  formatParcelStatusUpdateToastMessage,
  shouldSuppressParcelBookingNotification,
} from "../utils/parcelBookingNotifications";

/**
 * User role: CustomerGroup_{UserId} — refresh dashboard APIs on hub events.
 */
export function useCustomerSignalRNotifications(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;

    const service = getSignalRService();
    service.ensureBookingListenerRegistered();

    const handleHubMessage = (payload) => {
      if (process.env.NODE_ENV === "development") {
        console.info("[SignalR] Customer group event", payload);
      }

      const isSelf = shouldSuppressParcelBookingNotification(payload);

      refreshCustomerDashboardData().catch((err) => {
        console.warn("[SignalR] Customer dashboard refresh failed", err);
      });

      if (!isSelf) {
        toast.info(formatParcelStatusUpdateToastMessage(payload), {
          position: "top-right",
          autoClose: 8000,
        });
      }
    };

    service.on(PARCEL_STATUS_UPDATE_EVENT, handleHubMessage);

    return () => {
      service.off(PARCEL_STATUS_UPDATE_EVENT, handleHubMessage);
    };
  }, [enabled]);
}

export default useCustomerSignalRNotifications;
